function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _slicedToArray(r, e) { return _arrayWithHoles(r) || _iterableToArrayLimit(r, e) || _unsupportedIterableToArray(r, e) || _nonIterableRest(); }
function _nonIterableRest() { throw new TypeError("Invalid attempt to destructure non-iterable instance.\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method."); }
function _unsupportedIterableToArray(r, a) { if (r) { if ("string" == typeof r) return _arrayLikeToArray(r, a); var t = {}.toString.call(r).slice(8, -1); return "Object" === t && r.constructor && (t = r.constructor.name), "Map" === t || "Set" === t ? Array.from(r) : "Arguments" === t || /^(?:Ui|I)nt(?:8|16|32)(?:Clamped)?Array$/.test(t) ? _arrayLikeToArray(r, a) : void 0; } }
function _arrayLikeToArray(r, a) { (null == a || a > r.length) && (a = r.length); for (var e = 0, n = Array(a); e < a; e++) n[e] = r[e]; return n; }
function _iterableToArrayLimit(r, l) { var t = null == r ? null : "undefined" != typeof Symbol && r[Symbol.iterator] || r["@@iterator"]; if (null != t) { var e, n, i, u, a = [], f = !0, o = !1; try { if (i = (t = t.call(r)).next, 0 === l) { if (Object(t) !== t) return; f = !1; } else for (; !(f = (e = i.call(t)).done) && (a.push(e.value), a.length !== l); f = !0); } catch (r) { o = !0, n = r; } finally { try { if (!f && null != t.return && (u = t.return(), Object(u) !== u)) return; } finally { if (o) throw n; } } return a; } }
function _arrayWithHoles(r) { if (Array.isArray(r)) return r; }
import React, { Fragment, useState } from 'react';
import PropTypes from 'prop-types';
import isEmpty from 'lodash/isEmpty';
import { withMedia } from 'react-media-query-hoc';
import { TickIcon } from '@domain-group/fe-co-icon';
import { Button, Heading } from '@domain-group/fe-co-allhomes-design-system';
import { NbnCardGraphQL } from '../nbn-card';
import { PrimaryFeature, PrimaryFeaturePropTypes } from './primary-feature';
import * as styles from './features.style';
import { jsx as ___EmotionJSX } from "@emotion/core";
export var BaseFeatures = _ref => {
  var title = _ref.title,
    primaryFeatures = _ref.primaryFeatures,
    secondaryFeatures = _ref.secondaryFeatures,
    media = _ref.media,
    property = _ref.property;
  var NUM_DISPLAYED_FEATURES = 5;
  var mobile = media.mobile;
  var _useState = useState(false),
    _useState2 = _slicedToArray(_useState, 2),
    expanded = _useState2[0],
    setExpanded = _useState2[1];
  var _useState3 = useState(mobile ? secondaryFeatures === null || secondaryFeatures === void 0 ? void 0 : secondaryFeatures.slice(0, NUM_DISPLAYED_FEATURES) : secondaryFeatures),
    _useState4 = _slicedToArray(_useState3, 2),
    secondaryFeatureList = _useState4[0],
    setSecondaryFeatureList = _useState4[1];
  var viewMoreButton = !expanded && (secondaryFeatures === null || secondaryFeatures === void 0 ? void 0 : secondaryFeatures.length) > NUM_DISPLAYED_FEATURES ? ___EmotionJSX(Button, {
    css: styles.button,
    appearance: "outline",
    size: "small",
    onClick: () => {
      setExpanded(!expanded);
      setSecondaryFeatureList(secondaryFeatures);
    }
  }, ___EmotionJSX("div", {
    css: styles.buttonText
  }, "View all features")) : undefined;
  return ___EmotionJSX(Fragment, null, ___EmotionJSX(Heading, {
    title: title
  }), !isEmpty(primaryFeatures) && ___EmotionJSX("div", {
    css: styles.primaryFeatures
  }, primaryFeatures.map(feature => ___EmotionJSX(PrimaryFeature, _extends({
    key: feature.title
  }, feature)))), !isEmpty(secondaryFeatures) && ___EmotionJSX("div", {
    css: styles.secondaryFeatures
  }, secondaryFeatureList.map(feature => ___EmotionJSX("div", {
    key: feature,
    css: styles.secondaryFeature
  }, ___EmotionJSX(TickIcon, null), ___EmotionJSX("div", null, feature))), viewMoreButton), ___EmotionJSX(NbnCardGraphQL, {
    property: property
  }));
};
BaseFeatures.propTypes = {
  title: PropTypes.string,
  primaryFeatures: PropTypes.arrayOf(PrimaryFeaturePropTypes),
  secondaryFeatures: PropTypes.arrayOf(PropTypes.string),
  media: PropTypes.shape({
    mobile: PropTypes.bool
  }),
  property: PropTypes.shape({})
};
BaseFeatures.defaultProps = {
  title: 'Property features',
  primaryFeatures: [],
  secondaryFeatures: [],
  media: {},
  property: {}
};
export var Features = withMedia(BaseFeatures);